module.exports = __webpack_public_path__ + "img/banner-3-zh.c5330655.png";